var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-form-group',{attrs:{"label":"تخفیف"}},[_c('Discount',{model:{value:(_vm.realValue),callback:function ($$v) {_vm.realValue=$$v},expression:"realValue"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }